import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '~environments/environment';
import {ProductVersion} from 'src/app/core/models';

/**
 * Footer service to retrieve versioning of frontend and backend to display
 */
@Injectable({
  providedIn: 'root'
})
export class FooterService {
  public API_URL: any = environment.envAPI;
  public currentVersioning: BehaviorSubject<ProductVersion> = new BehaviorSubject<ProductVersion>(null);
  public castCurrentVersioning: any = this.currentVersioning.asObservable();

  constructor(private http: HttpClient) {
  }

  /**
   * Get versioning.
   */
  public get(): Observable<ProductVersion> {
    return this.http.get<ProductVersion>(`${this.API_URL}/product-version`);
  }

  /**
   * Sets a new version to the observable
   */
  public setCurrentVersioning(versioning: ProductVersion): void {
    this.currentVersioning.next(versioning);
  }
}
